import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "incredi-table-row font-gordita-medium text-[13px] tabular-nums lining-nums ml-3" }
const _hoisted_2 = { class: "font-gordita-regular py-3 pl-[12px] flex items-center justify-between bg-System/app_white outline outline-1 outline-System/app_border whitespace-nowrap" }
const _hoisted_3 = { class: "text-[11px] leading-[15px] mr-[16px] text-Text/text_medium flex items-center" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  "data-testid": "users-table--total-number",
  class: "text-Text/text_high"
}
const _hoisted_6 = {
  key: 0,
  "data-testid": "users-table--total-number-text",
  class: "text-Text/text_medium"
}
const _hoisted_7 = {
  key: 1,
  "data-testid": "users-table--total-number-text",
  class: "text-Text/text_medium"
}
const _hoisted_8 = {
  key: 1,
  "data-testid": "users-table--total-number-text"
}

import elementIds from '@/const/elementIds.json';
import { IncrediTable } from 'incredi-ui';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { ref, inject, onMounted, computed, onUnmounted } from 'vue';
import { User, UsersQuery, User_SortField, User_SortOrder, User_Status } from '@/graphql/codegen/generated/graphql';
import { IKRightDrawer } from '@/views/Layout/RightDrawer.InjectionKeys';
import EmptyUsersSearch from '@/components/common/empty-table-placeholder.vue';
import { dateUtils } from '@/services/dateUtils';
import UsersTableCell from './UserRows/cells/UsersTableCell.vue';
import UserRoleCell from './UserRows/cells/UserRoleCell.vue';
import UserNameCell from './UserRows/cells/UserNameCell.vue';
import UserFullNameCell from './UserRows/cells/UserFullNameCell.vue';
import FloatingEditCell from './UserRows/cells/FloatingEditCell.vue';
import UserStatusCell from './UserRows/cells/UserStatusCell.vue';
import UserTableCellWrapper from './UserRows/userTableCellWrapper.vue';
import { MAP_COLUMNS_To_User_SortField, MAP_User_SortField_To_COLUMNS } from './users-table.const';
import EditUser from './editUser.vue';
import { useUsersPage } from '../users.helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'users-table',
  props: {
    users: null
  },
  setup(__props: any) {

const usersPage = useUsersPage();

const hoveredRow = ref<number | undefined>(undefined);
const rightDrawer = inject(IKRightDrawer);


const handleEditClick = async (user: User) => {
  if (usersPage?.editUserForm.form.meta.value.dirty) {
    const confirmModal = await usersPage?.editUserForm.editUserConfirmationModal();
    if (confirmModal.ok && !confirmModal.formSuccessfullySubmitted) {
      // In case of invalid form
      return;
    }
  }
  if (user.id === usersPage?.usersTable.selectedUser.get.userData.value?.id) {
    usersPage?.usersTable.selectedUser.clear();
    rightDrawer?.close();
    return;
  }
  if (user) {
    usersPage?.usersTable.selectedUser.set(user);
  }
  usersPage?.editUserForm.form.resetForm({
    values: {
      userName: user.userName,
      email: user.additionalInfo?.email || '',
      firstName: user.additionalInfo?.firstName || '',
      lastName: user.additionalInfo?.lastName || '',
      role: user.role,
      status: user.status || User_Status.Inactive,
      password: '',
      confirmPassword: '',
    },
  });
  rightDrawer?.open(EditUser, {});
};

const isActive = (user: User | null | undefined) => user?.status === User_Status.Active || user?.status === User_Status.Locked;

const menuRowIndex = ref<undefined | number>(undefined);
const handleMenuVisibility = (index: number, visibility: boolean) => {
  if (visibility) {
    menuRowIndex.value = index;
  } else {
    menuRowIndex.value = undefined;
  }
};

const handleSortChange = (tableState: any) => {
  usersPage?.usersTable.filters?.sort.set({
    field: MAP_COLUMNS_To_User_SortField[tableState.sort?.name as keyof typeof MAP_COLUMNS_To_User_SortField],
    order: tableState.sort?.descending ? User_SortOrder.Descending : User_SortOrder.Ascending,
  });
};

const hasFilters = computed(() => usersPage?.usersTable.filters?.search.get.value !== '' || usersPage?.usersTable.filters?.status.get.value !== 'All');

const clearFilters = () => usersPage?.usersTable?.filters.clear();

const handleHoverRow = (index: number | undefined) => {
  hoveredRow.value = index;
};

const hoveredRowIndex = computed(() => (menuRowIndex.value !== undefined ? menuRowIndex.value : hoveredRow.value));

onMounted(() => {
  rightDrawer?.close();
});

onUnmounted(() => {
  usersPage?.usersTable.selectedUser.clear();
});

const columns = [
  { width: 60, name: 'ID', sortable: true, defaultSortOrder: User_SortOrder.Ascending },
  { minWidth: 145, name: 'Username', sortable: true, defaultSortOrder: User_SortOrder.Ascending },
  { minWidth: 145, name: 'Name', sortable: true, defaultSortOrder: User_SortOrder.Ascending },
  { minWidth: 145, name: 'Role', sortable: true, defaultSortOrder: User_SortOrder.Ascending },
  { minWidth: 145, name: 'Last Login', sortable: true, defaultSortOrder: User_SortOrder.Descending },
  { minWidth: 145, name: 'Status', sortable: true, defaultSortOrder: User_SortOrder.Ascending },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      (__props.users?.length)
        ? (_openBlock(), _createBlock(_unref(IncrediTable), {
            key: 0,
            "model-value": {
        sort: {
          name: _unref(MAP_User_SortField_To_COLUMNS)[_unref(usersPage)?.usersTable?.filters?.sort?.get?.value?.field || _unref(User_SortField).UserName],
          descending: _unref(usersPage)?.usersTable.filters.sort.get.value?.order === _unref(User_SortOrder).Descending,
        },
      },
            "row-height": 48,
            "data-testid": _unref(elementIds).users.usersTable,
            class: _normalizeClass(["users-table flex-grow w-full h-full", {
        'pointer-events-none': menuRowIndex.value !== undefined,
      }]),
            columns: columns as any,
            items: (__props.users as any) || [],
            "header-tooltip": true,
            "hovered-row-prop": _unref(hoveredRowIndex),
            "show-separators": false,
            onHoveredRow: handleHoverRow,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = 
        (tableState) => {
          handleSortChange(tableState);
        }
      )
          }, {
            "floating-row": _withCtx(({ index, value }) => [
              _createVNode(UserTableCellWrapper, {
                floating: "",
                selected: value.id === _unref(usersPage)?.usersTable.selectedUser.get.userData.value?.id
              }, {
                default: _withCtx(() => [
                  (index === _unref(hoveredRowIndex))
                    ? (_openBlock(), _createBlock(FloatingEditCell, {
                        key: 0,
                        "data-cy-edit-user-cell": value.userName,
                        "is-hovered": value.id === _unref(usersPage)?.usersTable.selectedUser.get.userData.value?.id,
                        onEditUser: ($event: any) => (handleEditClick(value as unknown as User))
                      }, null, 8, ["data-cy-edit-user-cell", "is-hovered", "onEditUser"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["selected"])
            ]),
            "content-ID": _withCtx(({ value }: { value: User }) => [
              _createVNode(UserTableCellWrapper, {
                "data-cy-user-name": value.userName,
                "data-testid": _unref(elementIds).users.table.cells.id,
                selected: value.id === _unref(usersPage)?.usersTable.selectedUser.get.userData.value?.id,
                "is-active": isActive(value)
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, _toDisplayString(value?.id), 1)
                ]),
                _: 2
              }, 1032, ["data-cy-user-name", "data-testid", "selected", "is-active"])
            ]),
            "content-Username": _withCtx(({ index, value }: { index: number, value: User }) => [
              _createVNode(UserTableCellWrapper, {
                "data-cy-user-name": value.userName,
                "data-testid": _unref(elementIds).users.table.cells.username,
                selected: value.id === _unref(usersPage)?.usersTable.selectedUser.get.userData.value?.id,
                "is-active": isActive(value)
              }, {
                default: _withCtx(() => [
                  _createVNode(UserNameCell, {
                    "data-cy-user-name": value?.userName,
                    "is-hovered": index === _unref(hoveredRowIndex),
                    email: value?.additionalInfo?.email,
                    selected: value.id === _unref(usersPage)?.usersTable.selectedUser.get.userData.value?.id,
                    "is-active": isActive(value),
                    username: value?.userName,
                    onEditUser: ($event: any) => (handleEditClick(value))
                  }, null, 8, ["data-cy-user-name", "is-hovered", "email", "selected", "is-active", "username", "onEditUser"])
                ]),
                _: 2
              }, 1032, ["data-cy-user-name", "data-testid", "selected", "is-active"])
            ]),
            "content-Name": _withCtx(({ value }: { value: User }) => [
              _createVNode(UserTableCellWrapper, {
                "data-cy-user-name": value.userName,
                "data-testid": _unref(elementIds).users.table.cells.fullName,
                selected: value.id === _unref(usersPage)?.usersTable.selectedUser.get.userData.value?.id,
                "is-active": isActive(value)
              }, {
                default: _withCtx(() => [
                  _createVNode(UserFullNameCell, {
                    "first-name": value?.additionalInfo?.firstName,
                    "last-name": value?.additionalInfo?.lastName
                  }, null, 8, ["first-name", "last-name"])
                ]),
                _: 2
              }, 1032, ["data-cy-user-name", "data-testid", "selected", "is-active"])
            ]),
            "content-Role": _withCtx(({ index, value }: { index: number, value: User }) => [
              _createVNode(UserTableCellWrapper, {
                "data-cy-user-name": value.userName,
                "data-testid": _unref(elementIds).users.table.cells.role,
                selected: value.id === _unref(usersPage)?.usersTable.selectedUser.get.userData.value?.id
              }, {
                default: _withCtx(() => [
                  _createVNode(UserRoleCell, {
                    borderless: index !== _unref(hoveredRowIndex),
                    user: value,
                    "model-value": value?.role,
                    selected: value.id === _unref(usersPage)?.usersTable.selectedUser.get.userData.value?.id,
                    "is-active": isActive(value),
                    onMenuVisibility: ($event: any) => (handleMenuVisibility(index, $event))
                  }, null, 8, ["borderless", "user", "model-value", "selected", "is-active", "onMenuVisibility"])
                ]),
                _: 2
              }, 1032, ["data-cy-user-name", "data-testid", "selected"])
            ]),
            "content-LastLogin": _withCtx(({ value }: { value: User }) => [
              _createVNode(UserTableCellWrapper, {
                "data-cy-user-name": value.userName,
                "data-testid": _unref(elementIds).users.table.cells.lastLogin,
                selected: value.id === _unref(usersPage)?.usersTable.selectedUser.get.userData.value?.id,
                "is-active": isActive(value)
              }, {
                default: _withCtx(() => [
                  _createVNode(UsersTableCell, {
                    class: "incredi-table-row",
                    value: value?.lastLogin ? _unref(dateUtils).getFormattedDate(value?.lastLogin) : null
                  }, null, 8, ["value"])
                ]),
                _: 2
              }, 1032, ["data-cy-user-name", "data-testid", "selected", "is-active"])
            ]),
            "content-Status": _withCtx(({ value }: { value: User }) => [
              _createVNode(UserTableCellWrapper, {
                selected: value.id === _unref(usersPage)?.usersTable.selectedUser.get.userData.value?.id,
                "is-active": isActive(value),
                "data-cy-user-name": value.userName,
                "data-testid": _unref(elementIds).users.table.cells.status
              }, {
                default: _withCtx(() => [
                  _createVNode(UserStatusCell, {
                    class: "incredi-table-row",
                    status: value?.status || _unref(User_Status)['Inactive']
                  }, null, 8, ["status"])
                ]),
                _: 2
              }, 1032, ["selected", "is-active", "data-cy-user-name", "data-testid"])
            ]),
            _: 1
          }, 8, ["model-value", "data-testid", "class", "columns", "items", "hovered-row-prop"]))
        : (_openBlock(), _createBlock(EmptyUsersSearch, {
            key: 1,
            "search-items-name": "users",
            "has-filters-applied": _unref(hasFilters),
            class: "flex-grow w-full h-full bg-System/app_white border-System/app_border border",
            onClearFilters: clearFilters
          }, null, 8, ["has-filters-applied"])),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (__props.users?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(__props.users?.length), 1),
                (__props.users.length === 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, " user"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_7, " total users"))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, " No users for display "))
        ])
      ])
    ]),
    _: 1
  }))
}
}

})